import * as React from "react";

import "./Icon.css";

const SvgRefreshIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Refresh_Icon_svg_Layer_1"
    data-name="Layer 1"
    viewBox="0 0 44.5 47.52"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon Refresh_Icon  ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <defs>
      <style>
        {
          ".Refresh_Icon_svg_cls-2{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;fill:none;stroke-width:4px;}"
        }
      </style>
    </defs>
    <path
      id="Refresh_Icon_svg_Arrow"
      d="M26.6 12.75 31.18.5 20.69 3.74h0z"
      style={{
        fill: "currentColor",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
    />
    <circle
      id="Refresh_Icon_svg_Head"
      cx={22.25}
      cy={25.27}
      r={20.25}
      className="Refresh_Icon_svg_cls-2"
    />
  </svg>
);
export default SvgRefreshIcon;
